/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
export const withStoryPageContent = async (Component, subPageType) => {
  const StoryComponent = await getStoryComponent(subPageType);
  const renderStoryPageContent = props => <StoryComponent {...props} />;
  const Comp = props => {
    return <Component renderStoryPageContent={renderStoryPageContent} {...props} />;
  };
  return Comp;
};

export const getStoryComponent = async subPageType => {
  let storyModulePath = "/text-story";
  switch (subPageType) {
    case "text":
      storyModulePath = "/text-story";
      break;
    case "live-blog":
      storyModulePath = "/live-blog";
      break;
    case "video":
      storyModulePath = "/video-story";
      break;
    case "photo":
      storyModulePath = "/photo-story";
      break;
    case "visual-story":
      storyModulePath = "/visual-story";
      break;
    case "listicle":
      storyModulePath = "/listicle-story";
      break;
    case "other":
      storyModulePath = "/other";
      break;
    default:
      storyModulePath = "/text-story";
  }
  const { default: StoryComponent } = await import(
    /* webpackChunkName: "StoryTemplateChunk[request]" */
    /* webpackPreload: true */ "../components/story-templates" + storyModulePath
  );
  return StoryComponent;
};
